export default "__VITE_ASSET__DrRo58M9__"